import Wrapper from '../../layouts/Wrapper/Wrapper';
import ApprovalRules from './ApprovalRules/ApprovalRules';
import { HeaderTabNavigation, Headers } from 'components/core';
import { handleSettingsTabNavData } from 'constants/TabNavData';

const SettingsApprovalRulesContainer = () => {
  const [settingsTabNavData] = handleSettingsTabNavData();

  return (
    <Wrapper additionalClasses="flex-col items-start" pageTitle="Settings">
      <Headers headingContent="Settings" isSignOutButton headerWrapperClasses="border-none" />
      <HeaderTabNavigation tabNavData={settingsTabNavData} />
      <ApprovalRules />
    </Wrapper>
  );
};

export default SettingsApprovalRulesContainer;
